// @core/api/endpoints/platform/index.ts
// Auto-generated by corebuilder. DO NOT EDIT.
import { AcceptFederationPeer } from './accept_federation_peer';
import { AcceptPlatformInvitation } from './accept_platform_invitation';
import { AddPlatformMember } from './add_platform_member';
import { CancelPlatformInvitation } from './cancel_platform_invitation';
import { CheckFederationHealth } from './check_federation_health';
import { CreateFederationPeer } from './create_federation_peer';
import { CreatePlatform } from './create_platform';
import { CreatePlatformInvitation } from './create_platform_invitation';
import { DeclinePlatformInvitation } from './decline_platform_invitation';
import { DeletePlatform } from './delete_platform';
import { DisablePlatformProduct } from './disable_platform_product';
import { DiscoverPlatforms } from './discover_platforms';
import { EnablePlatformProduct } from './enable_platform_product';
import { GetConsentStatus } from './get_consent_status';
import { GetDataResidencyPolicy } from './get_data_residency_policy';
import { GetFederationHealthHistory } from './get_federation_health_history';
import { GetFederationPeer } from './get_federation_peer';
import { GetPlatform } from './get_platform';
import { GetPlatformBranding } from './get_platform_branding';
import { GetPlatformLimits } from './get_platform_limits';
import { GetPlatformProduct } from './get_platform_product';
import { GetPlatformSettings } from './get_platform_settings';
import { GetPlatformUsage } from './get_platform_usage';
import { GetRegisteredPlatform } from './get_registered_platform';
import { GrantDataConsent } from './grant_data_consent';
import { ListConsentRecords } from './list_consent_records';
import { ListFederationPeers } from './list_federation_peers';
import { ListPlatformInvitations } from './list_platform_invitations';
import { ListPlatformMembers } from './list_platform_members';
import { ListPlatformProducts } from './list_platform_products';
import { ListPlatforms } from './list_platforms';
import { RegisterInRegistry } from './register_in_registry';
import { RemovePlatformMember } from './remove_platform_member';
import { ResolveFederatedResource } from './resolve_federated_resource';
import { RevokeDataConsent } from './revoke_data_consent';
import { RevokeFederationPeer } from './revoke_federation_peer';
import { SetPlatformProductStatus } from './set_platform_product_status';
import { SetPlatformStatus } from './set_platform_status';
import { SyncFederationCatalog } from './sync_federation_catalog';
import { TransferPlatformOwnership } from './transfer_platform_ownership';
import { UpdateDataResidencyPolicy } from './update_data_residency_policy';
import { UpdateFederationPeer } from './update_federation_peer';
import { UpdatePlatform } from './update_platform';
import { UpdatePlatformBranding } from './update_platform_branding';
import { UpdatePlatformLimits } from './update_platform_limits';
import { UpdatePlatformMemberRole } from './update_platform_member_role';
import { UpdatePlatformProduct } from './update_platform_product';
import { UpdatePlatformSettings } from './update_platform_settings';

// Re-export individual endpoints
export {
  AcceptFederationPeer,
  AcceptPlatformInvitation,
  AddPlatformMember,
  CancelPlatformInvitation,
  CheckFederationHealth,
  CreateFederationPeer,
  CreatePlatform,
  CreatePlatformInvitation,
  DeclinePlatformInvitation,
  DeletePlatform,
  DisablePlatformProduct,
  DiscoverPlatforms,
  EnablePlatformProduct,
  GetConsentStatus,
  GetDataResidencyPolicy,
  GetFederationHealthHistory,
  GetFederationPeer,
  GetPlatform,
  GetPlatformBranding,
  GetPlatformLimits,
  GetPlatformProduct,
  GetPlatformSettings,
  GetPlatformUsage,
  GetRegisteredPlatform,
  GrantDataConsent,
  ListConsentRecords,
  ListFederationPeers,
  ListPlatformInvitations,
  ListPlatformMembers,
  ListPlatformProducts,
  ListPlatforms,
  RegisterInRegistry,
  RemovePlatformMember,
  ResolveFederatedResource,
  RevokeDataConsent,
  RevokeFederationPeer,
  SetPlatformProductStatus,
  SetPlatformStatus,
  SyncFederationCatalog,
  TransferPlatformOwnership,
  UpdateDataResidencyPolicy,
  UpdateFederationPeer,
  UpdatePlatform,
  UpdatePlatformBranding,
  UpdatePlatformLimits,
  UpdatePlatformMemberRole,
  UpdatePlatformProduct,
  UpdatePlatformSettings,
};

// Namespace export for convenient usage
export const platformApi = {
  AcceptFederationPeer,
  AcceptPlatformInvitation,
  AddPlatformMember,
  CancelPlatformInvitation,
  CheckFederationHealth,
  CreateFederationPeer,
  CreatePlatform,
  CreatePlatformInvitation,
  DeclinePlatformInvitation,
  DeletePlatform,
  DisablePlatformProduct,
  DiscoverPlatforms,
  EnablePlatformProduct,
  GetConsentStatus,
  GetDataResidencyPolicy,
  GetFederationHealthHistory,
  GetFederationPeer,
  GetPlatform,
  GetPlatformBranding,
  GetPlatformLimits,
  GetPlatformProduct,
  GetPlatformSettings,
  GetPlatformUsage,
  GetRegisteredPlatform,
  GrantDataConsent,
  ListConsentRecords,
  ListFederationPeers,
  ListPlatformInvitations,
  ListPlatformMembers,
  ListPlatformProducts,
  ListPlatforms,
  RegisterInRegistry,
  RemovePlatformMember,
  ResolveFederatedResource,
  RevokeDataConsent,
  RevokeFederationPeer,
  SetPlatformProductStatus,
  SetPlatformStatus,
  SyncFederationCatalog,
  TransferPlatformOwnership,
  UpdateDataResidencyPolicy,
  UpdateFederationPeer,
  UpdatePlatform,
  UpdatePlatformBranding,
  UpdatePlatformLimits,
  UpdatePlatformMemberRole,
  UpdatePlatformProduct,
  UpdatePlatformSettings,
};
